import React, { Component } from 'react'
import Responsive from '../../Responsive'
// import Slider from '../../slider/Slider'
import SliderSingle from '../../slider/SliderSingle'




export default class Overview extends Component {
    state = {
        info: [
            { title: "Offered by", des: "zoom.us" },
            { title: "Version", des: "1.8.13" },
            { title: "Updated", des: "March 6, 2023" },
            { title: "Size", des: "235KiB" },
            { title: "Languages", des: "English, French, Spanish" },
            { title: "Developer", des: "This developer has identified itself as a trader per the definition from the European Union." },

        ]
    }

    render() {
        return (
            <div className='w-100'>
                <div className='d-flex' style={{ backgroundColor: "#fff" }}>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", }}>
                        <div className='p-4 flexcc flex-column'>
                            <div className='flexcc w-100'>
                                <div className='flexcc' style={{ maxWidth: "800px" }}>
                                    <SliderSingle />
                                </div>
                            </div>
                            <div className='mrd-4 p-4 m-1' style={{ maxWidth: "800px" }}>
                                <p className='font-size-14 weight-500' style={{ color: "#333" }}>Overview</p>
                                <p className='font-size-12 mt-2' style={{ color: "#777" }}>Zoom, the cloud meeting company, unifies mobile collaboration, cloud video conferencing and simple online meetings into one easy-to-use platform. Our solution offers the best video, audio and screen-sharing experience across Windows PC, Mac, iOS, Android and H.323/SIP room systems</p>
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
